module.exports = __webpack_public_path__ + "public/img/guoqi.53204b3a.png";